import type { FaireProductEntity } from "../../entity_types/product";

export const p_9x43x8wn92: FaireProductEntity = {
  token: "p_9x43x8wn92",
  type: "product",
  name: "Sanctuary Glass Candle – 100% Pure Beeswax – 90 Hour Burn",
  brandToken: "b_thcq7n2zrb",
  brandName: "Big Dipper Wax Works",
  imageUrl:
    "https://cdn.faire.com/fastly/2eb86424ac22c2cc6ea82c3c3f7288278c233404094c8bd8780d3c2d58ac4962.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dfca9be067a3d812980c65c22f2a80b3ede8b398e03916567c9d06db29f903d5.jpeg",
    "https://cdn.faire.com/fastly/745a6c9acb312788d77579d007f5f944514bbf7b00ab38f95ad91c538cf49f1d.jpeg",
    "https://cdn.faire.com/fastly/823a59bfdfcd3f61a3ab0b598358f2b56599208757b51c475e4497aa68b5c344.jpeg",
    "https://cdn.faire.com/fastly/d04e7d0ab61c947e743de4557f9fb215eca5c4cae642b38f6d9ce04980919b69.jpeg",
    "https://cdn.faire.com/fastly/c319f6549716bd46aaa660cfe410dd41121e4c8bb28b873375e30d7222d631a8.jpeg",
    "https://cdn.faire.com/fastly/91ecff4bf8ddbc3faa622535258a57ea66b420c190fd2ed10244fdb71284d33d.jpeg",
    "https://cdn.faire.com/fastly/7b9a13132b1181bac9e772c89b4c282101fdb451d1a54d4b474855ffa73b5c8c.jpeg",
    "https://cdn.faire.com/fastly/47d1c6fe39a88bb87a663afd8ea6e26fb05418b19bd826692eba972d625a94e4.jpeg",
    "https://cdn.faire.com/fastly/dd23a49c8fd3643fd301b2e173ba5f978a8bd0911a3b629ff686d4f54cfcdf79.jpeg",
    "https://cdn.faire.com/fastly/e872507a9cea693b191130e89f7a6c62d8eb9268de52cf3a8f5e5554b8a268ec.jpeg",
    "https://cdn.faire.com/fastly/0075277cacf4fd09d28d6bcf951cd43b1ce7ed2afe6b898a331e48aaa7ad985b.jpeg",
    "https://cdn.faire.com/fastly/45771f086ce965dee5b50e97b78d7e07b69817caa245c9b96627144656ac8554.jpeg",
  ],
  priceDollars: 23.9,
  description:
    'The Sanctuary Glass Candle from Big Dipper Wax Works offers a 90-hour burn in an elegant 12.5 oz glass jar. Hand-poured with 100% pure beeswax and scented only with therapeutic-grade essential oils, it’s free of synthetic fragrances and toxins. Each candle features a removable label reflecting its aromatherapy blend—choose from seven all-natural scents to uplift, relax, or invigorate your space. Perfect for home décor, spa settings, or gifting, its tall design creates a striking focal point while releasing beeswax’s natural honey-like aroma.\n\nSize: 12.5 oz (2.5" x 8") | Burn Time: 90 hrs\n\nWax: 100% pure beeswax with essential oils | Cotton wick | Paraffin-free\n\nClean-burning, handcrafted, non-toxic, soy-free, lead-free.\n\nLearn more at BigDipperWaxWorks.com.',
  tags: [],
  msrpDollars: 47.81,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:11.325Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
